import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";
import { baseUrl } from "../../../shared/config";

export const getBackgrounds = async () => {
  const res = await fetch(
    "https://middleware.cadernovirtual.com.br/Social.asmx/Backgrounds",
    {
      headers: {
        "Content-Type": "application/json",
        token: _cookies.getItem("auth").token,
      },
    }
  );
  const data = await res.json();

  return data.d.arquivos.map((value) => `${baseUrl}/Membros/images/${value}`);
};

export const useBackgrounds = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["socialMediaBackgrounds"],
    queryFn: getBackgrounds,
  });
};
